var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.stepName},[_vm._m(0),_vm._v(" "),_c('AddressForm')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-header"},[_c('p',[_vm._v("Pour accéder à tous les services, recevoir nos magazines et votre cadeau de bienvenue, remplissez les champs suivants :")])])
}]

export { render, staticRenderFns }